import React from 'react';
import { Form, Button, Icon } from 'semantic-ui-react';
//import { Field } from 'formik';
import moment from 'moment';
import FormikInputField from '../componentsFormik/FormikInputField';

// import DBAContentTop from '../componentsContent/DBAContentTop';
// import DBAContentBottom from '../componentsContent/DBAContentBottom';

import DBAContentBoots from '../componentsContent/DBAContentBoots';


class DBAFormTwo extends React.Component<any, any> {
  private lis = new Array<HTMLElement>(1);

  handleShow = (i: number) => {
    this.lis[i].scrollIntoView({ block: 'end', behavior: 'smooth' });
  };

  prev = (e: any) => {
    e.preventDefault();
    this.props.prevStep();
  };

  next = (e: any) => {
    e.preventDefault();
    this.props.values.stp7_dbaAgreed = true;
    this.props.values.stp7_dbaAgreedTS = moment().format('DD/MM/YYYY, HH:mm:ss');

    // this.props.setFieldValue('stp7_dbaAgreedSignature', 'xxx');
    // setTimeout(() => {
    //   this.props.nextStep(this.props);
    // }, 150);
    this.props.gaEvent('event', 'SignDBA', 'Agree', 'Boots', this.props.isValid);
    this.props.nextStep(this.props);
  }

  renderScrollBtn(direction: string) {


    return (
      <div style={{ textAlign: 'center' }}>
        <Button
          onClick={(e) => {
            this.handleShow(0)
          }}
          style={{ borderBottom: "solid 3px #209639" }}
          circular
          positive
          icon
          size="big"
          data-testid={`dba-button-scroll-${direction}`}
        >
          <Icon
            style={{ textShadow: "1px -1px #888888, 1px -3px #209639" }}
            size="big"
            name={direction === 'up' ? 'arrow up': 'arrow down'}
          />
        </Button>
        <p style={{ fontSize: '20px', color: 'black' }}>Scroll to Accept</p>
      </div>
    );
  }

  renderProceedBtn() {
    return (
      <Button.Group widths="2" style={{ margin: '10px auto' }}>
        <Button
          disabled={!(this.props.values.stp7_dbaAgreedSignature)}
          labelPosition="right"
          color={this.props.isValid ? 'green' : 'grey'}
          icon="right chevron"
          content={<div>Adopt Signature and Agree to DBA</div>}
          onClick={this.next}
          data-testid="dba-button-agree"
        />
      </Button.Group>
    );
  }

  render() {
    return (
      <React.Fragment>
        <Form.Group grouped>

          <React.Fragment>
            <div
              id="dba-message"
              style={{ fontSize: '16px', marginBottom: '15px' }}
            >
              This is your Damages-Based Agreement. Please read through the document
              and agree to the terms and conditions by signing digitally. By clicking
              'Adopt Signature and Agree to DBA' we can continue with your claim.
            </div>

            {this.renderScrollBtn('down')}

            <div
              style={{
                height: '500px',
                boxShadow:
                  '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px  rgba(0, 0, 0, 0.19)',
                overflowX: 'hidden',
                overflowY: 'scroll',
                padding: '30px',
                margin: '15px auto'
              }}
            >

              {/* <DBAContentTop name="something" /> */}

              <DBAContentBoots
                revisitingLead={this.props.values.revisitingLead}
                firstName={this.props.values.stp4_firstName}
                lastName={this.props.values.stp4_lastName}
                houseNumName={this.props.values.stp3_houseNumName}
                streetRoad={this.props.values.stp3_streetRoad}
                town={this.props.values.stp3_town}
                postCode={this.props.values.stp3_postCode}
                country={this.props.values.stp3_country}
              />

              <div className="signing-box">

                <p><b>SIGN HERE:</b></p>

                <FormikInputField
                  name="stp7_dbaAgreedSignature"
                  type="input"
                  placeholder="Your Signature"
                  style={{ fontFamily: 'Caveat, cursive', fontSize: '22px' }}
                  onChange={(e: any) => {
                    this.props.setFieldValue(e.target.name, e.target.value);
                  }}
                  data-testid="dba-input-signature"
                />

                {/* <Field type="hidden" name="stp7_dbaAgreed" value={false} />
                <Field type="hidden" name="stp7_dbaAgreedTS" value="" /> */}

                {this.renderProceedBtn()}

                <Button.Group widths="2" style={{ margin: '10px auto' }}>
                  <Button
                    type="button"
                    color="red"
                    content={<div>Reset</div>}
                    onClick={() => this.props.setFieldValue('stp7_dbaAgreedSignature', '')}
                    data-testid="dba-input-reset"
                  />
                </Button.Group>

                <p>
                  <span id="date1" />
                  <b data-testid="dba-text-date">Date {moment().format('DD/MM/YYYY')}</b>
                </p>

                <div
                  style={{ lineHeight: '200px' }}
                  ref={li => (this.lis[0] = li!)}
                  data-testid="dba-div-scrollIntoView"
                />

              </div>

              {/* <DBAContentBottom name="something" /> */}
            </div>

            {this.renderScrollBtn('up')}
          </React.Fragment>

          {this.renderProceedBtn()}

        </Form.Group>
      </React.Fragment>
    );
  }
}

export default DBAFormTwo;
